import styled from 'styled-components';

export const ModalOverlay = styled.div<{ width: number }>`
  .hefesto-modal__container {
    width: ${({ width }) => (width ? width : 0)}px;
  }
  .hefesto-modal__header {
    margin-bottom: 1rem;
    h3 {
      margin-bottom: 0;
      font-size: 20px;
      line-height: 28px;
      color: ${({ theme }) => theme.colors.grayDark3};
      font-weight: 400;
    }
  }
  .hefesto-modal__body {
    color: #414e55;
  }
`;

export const UpdateItemsContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1rem;
`;

export const UpdateItemsWrapper = styled.div`
  > span {
    display: block;
  }
`;

export const UpdateItemsAllowedText = styled.span`
  color: ${({ theme }) => theme.colors.grayDark4};
  font-weight: 700;
`;
